/*
 * @Descripttion: 产品列表
 * @Author: huangfuchunmei
 * @Date: 2023-08-29 15:56:48
 * @LastEditors: caiqin.xie
 * @LastEditTime: 2023-09-19 18:03:24
 */
import React from "react";
import { getFileExtension } from "@/common/untils";
import styles from "./index.module.scss";
import LazyMedia from "@/components/LazyMedia";
import BuyButton from "@/components/BuyButton";
import { IBanner } from "@/common/types";

interface IProps {
  productList: IBanner[]; // 产品数据
  ctry?: string;
  words: Record<string, string>;
}
const ProductList: React.FC<IProps> = ({ productList, words, ctry }) => {
  const moreClick = (item:Record<string, any>) => {
    if (item.linkUrl) {
      window.open(item.linkUrl, '_self');
    } else {
      window.open(`/${ctry}/support/product-parameter/${item.id}`, '_self');
    }
  }
  return (
    <>
      {productList && (
        <div className={styles["product-content-wrap"]}>
          <div className={styles["title-wrap"]}>
            <h2 className={styles["spread-head"]}>
              {words?.home_series_products}
            </h2>
            <h4 className={styles["sub-title"]}>
              {words?.home_series_products_description}
            </h4>
          </div>
          <div className={styles["list-wrap"]}>
            {productList?.map((item: IBanner) => (
              <div className={styles["item-wrap"]} key={item.id}>
                <div className={styles["item-wrap-box"]}>
                  <div className={styles["item-img"]}>
                    {item.cover &&
                      (getFileExtension(item.cover) === "mp4" ? (
                        <LazyMedia
                          type="video"
                          loop
                          autoPlay
                          preload="auto"
                          playsInline
                          muted
                          src={item.cover}
                        />
                      ) : (
                        <LazyMedia
                          type="image"
                          src={item.cover}
                          alt={item?.coverAlt}
                        />
                      ))}
                  </div>
                  <div className={styles["item-content"]}>
                    <h2>{item.name}</h2>
                    <h4 className="preLine">{item.briefIntroduction}</h4>
                    <div className={styles["btn-group"]}>
                      <BuyButton buyPaths={item.buyPaths} words={words} className={styles['custom-btn']} />
                      <a onClick={() => moreClick(item)}
                      >
                        <span className={styles["learn-more"]}>
                          {words?.common_learn_more}
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ProductList;
